import { SettingRow } from 'types/GlobalSimFlaw'

/**
 * The Datahälsa tabs. The slug is a path segment (`/internal/data-health/jobs`)
 * so a tab stays linkable and bookmarkable, while everything the tabs share -
 * the customer selection and the run context - is owned above them.
 */
export const DATA_HEALTH_TABS = [
  'overview',
  'jobs',
  'runs',
  'validation'
] as const

export type DataHealthTab = (typeof DATA_HEALTH_TABS)[number]

export const DEFAULT_DATA_HEALTH_TAB: DataHealthTab = 'overview'

export function dataHealthTabPath(tab: DataHealthTab): string {
  return `/internal/data-health/${tab}`
}

function isDataHealthTab(value?: string): value is DataHealthTab {
  return DATA_HEALTH_TABS.includes(value as DataHealthTab)
}

/** Anything unrecognized in the URL renders the overview. */
export function parseDataHealthTab(value?: string): DataHealthTab {
  return isDataHealthTab(value) ? value : DEFAULT_DATA_HEALTH_TAB
}

export type SimFlawSettings = { [tableName: string]: SettingRow }

/**
 * Swedish label for a raw SIM table or attribute name, shared so Översikt and
 * Datavalidering can't drift into naming the same table two different things.
 *
 * Falls back to the raw name: the labels come from their own endpoint, so a
 * card can render before they land.
 */
export function tableLabel(
  settings: SimFlawSettings,
  tableName: string
): string {
  return settings[tableName]?.label ?? tableName
}

export function attributeLabel(
  settings: SimFlawSettings,
  tableName: string,
  attributeName: string
): string {
  return (
    settings[tableName]?.attributes.find(
      (attribute) => attribute.value === attributeName
    )?.label ?? attributeName
  )
}
